/**
 * Preview 座位屏幕预览小图
 * props:
 *    data: 座位数据
 *  choose: 获取选中的座位
 *    show: 控制Preview是否现实
 */
import React, { useRef, useEffect } from 'react';
import styles from './style/index.less';
import SeaCanvas from './seaCanvas';
let SET_WIDTH = 20 / 2;
let SET_HEIGHT = 20 / 2;
export default function Preview(props) {
  const { data, show, Click, move } = props;
  const preview = useRef(null);
  const tips = useRef(null);

  useEffect(() => {
    // console.log('move', move);
    const { size, x, y } = move;

    if (!x && !y) return;
    const { w_s, h_s, w, h } = size;
    const width = (SET_WIDTH * data[0].length) / 2;
    const height = (SET_HEIGHT * data.length) / 2;
    console.log(width, height);
    tips.current.style.width = width * w_s + 'px';
    tips.current.style.height = height * h_s + 'px';
    console.log('--', width * size.w, height * size.h, size);
    tips.current.style.setProperty('--transformX', `${-(x / w) * width}px`);
    tips.current.style.setProperty('--transformY', `${-(y / h) * height}px`);
  }, [move]);
  useEffect(() => {
    if (data && tips?.current) {
      const width = (SET_WIDTH * data[0].length) / 2;
      const height = (SET_HEIGHT * data.length) / 2;
      tips.current.style.width = width + 'px';
      tips.current.style.height = height + 'px';
      tips.current.style.setProperty('--transformX', '0px');
      tips.current.style.setProperty('--transformY', '0px');
    }
  }, [data, tips]);
  return (
    <div
      className={` ${styles.preview} `}
      style={{ display: show ? 'block' : 'none' }}
      ref={preview}
      onClick={Click}
    >
      <b className={`${styles.tips}`} ref={tips}></b>
      <SeaCanvas data={data} getZoom={() => {}} getSeledSit={() => {}} />
    </div>
  );
}
